<div class="flex flex-col min-w-128 max-w-128 mobile:max-w-72 mobile:min-w-72 max-h-screen">
  <!-- Header -->
  <div class="px-6">
    <div class="flex flex-0 items-center justify-between h-14">
      <div class="text-2xl font-bold mobile:text-xl mobile:leading-5">Reset Your Login Password</div>
      <div class="primary-text cursor-pointer" (click)="signOut()">
        <span class="font-medium underline">Sign out</span>
      </div>
    </div>
    <mat-divider class="border"></mat-divider>
  </div>

  <!-- User Info -->
  <div class="px-6 text-lg pt-2 text-black font-medium truncate">
    {{ data.user_name }}
  </div>
  <div class="px-6 text-sm pt-1">
    Need to change password for first time login.
  </div>

  <!-- Form Content -->
  <div class="px-6 pb-6 pt-2">
    <!-- Alert -->
    @if (showAlert) {
      <fuse-alert class="mt-4" [appearance]="'outline'" [showIcon]="false"
        [type]="alert.type" [@shake]="alert.type === 'error'">
        <span [innerHTML]="alert.message"></span>
      </fuse-alert>
    }

    <!-- Set Password Form -->
    <form class="mt-2 space-y-3" [formGroup]="setPassForm">
      <!-- Password Field -->
      <mat-form-field class="w-full">
        <input id="password" matInput type="password" placeholder="New Password"
          formControlName="password" #passwordField
          pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$">
          <button mat-icon-button class="relative right-0" type="button"
            (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
            matSuffix>
            @if (passwordField.type === 'password') {
              <mat-icon class="icon-size-5"
              [svgIcon]="'heroicons_solid:eye'"></mat-icon>
            }
            @if (passwordField.type === 'text') {
              <mat-icon class="icon-size-5"
              [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
            }
          </button>
          @if (setPassForm.get('password').hasError('required')) {
            <mat-error>
              New Password is required
            </mat-error>
          }
          @if (!isPasswordValid(setPassForm.get('password').value) && !setPassForm.get('password').hasError('required')) {
            <mat-error>
              New Password must contain 1 upper case, 1 lower case, 1 number & 1 special character and must be 8 digits long.
            </mat-error>
          }
        </mat-form-field>

        <!-- Password Confirmation Field -->
        <mat-form-field class="w-full">
          <input id="passwordConfirm" matInput type="password" placeholder="Confirm password"
            formControlName="passwordConfirm" #confirmPasswordField
            pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$">
            <button mat-icon-button class="relative right-0" type="button"
              (click)="confirmPasswordField.type === 'password' ? confirmPasswordField.type = 'text' : confirmPasswordField.type = 'password'"
              matSuffix>
              @if (confirmPasswordField.type === 'password') {
                <mat-icon class="icon-size-5"
                [svgIcon]="'heroicons_solid:eye'"></mat-icon>
              }
              @if (confirmPasswordField.type === 'text') {
                <mat-icon class="icon-size-5"
                [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
              }
            </button>
            @if (setPassForm.get('passwordConfirm').hasError('required')) {
              <mat-error>
                Confirm Password is required
              </mat-error>
            }
            @if (setPassForm.get('passwordConfirm').hasError('passwordsNotMatching') && !setPassForm.get('passwordConfirm').hasError('required')) {
              <mat-error>
                Password and Confirm Password do not match.
              </mat-error>
            }
          </mat-form-field>

          <!-- Submit Button -->
          <div class="pt-2">
            <button class="dark-blue py-4 fuse-mat-button-large px-7 w-full" type="button"
              [disabled]="setPassForm.disabled" (click)="setPass()">
              @if (!setPassForm.disabled) {
                <span class="white-text tracking-wide">
                  Continue
                </span>
              }
            </button>
          </div>
        </form>
      </div>
    </div>